import React, {useState, useEffect, useCallback} from 'react';
import PropTypes from 'prop-types';
import './CounterApp.css';
import CounterView from './CounterView';

// set is object that keeps only unique data
const functions = new Set();
let cssShow = "none";
let cssHide = "inline";

const CounterApp = (props) => {

    // STATE (not props)
    const [count, setCount] = useState(0); 
    const {title} = props; // same as const title = props.title;
    const [tempX, setTempX] = useState(10);

    // This useEffect Hook is called if functional component is initialized or updated! if theere is nothing set to call this after thje {}, in []
    useEffect(() => {
        console.log("call useEffect");
    }, []
    );


    // cleaner version:
    // const increment = (step) => () => setCount(count + step);
    // const doTempX = () => setTempX(tempX + 1);
    const increment = useCallback((step) => () => setCount(count + step), [count]);
    const doTempX = useCallback(() => setTempX(tempX + 1), [tempX]); // update this function only when, [tempX] is changed!!!

    const showAdditionalStuff = () => {
        
        cssShow = "inline";
        cssHide = "none";
        //console.log("TRES");
    }
        
    

    //Testing if these are added on every app update (e.g. push of a doTempX button etc...) This will be fixed with useCallback function
    functions.add(increment);
    functions.add(doTempX);
    

    return (

        <div className="counter-app">
            <h1>{title}</h1>
            <h2>I am counter app!</h2>
                <CounterView 
                
                    countValue={count}
                    handleIncrement={increment}

                />

            <p></p>

            <div style={{display: cssShow}}>
                <button onClick={doTempX}>Test for not firing bgColorChange on every "update"</button>
                <h3>functions: {functions.size}</h3>
            </div>
            <button style={{display: cssHide}} onClick={showAdditionalStuff}>+</button>
            
        </div>
        
    )

}

CounterApp.propTypes = {
    title: PropTypes.string.isRequired
}





// class CounterApp extends React.Component {

//     constructor() {
//         super();

//         this.state = {
//             count: 0
//         }
//     }

//     /* YOU CAN CALL THIS INSIDE THE CONSTRUCTOR
//     state = {
//         count: 0
//     }
//     */

//     componentDidMount() {
//         //alert("Component did mount called! it is called at start");
//     }

//     componentDidUpdate() {
//         //alert("Component did update!");
//     }

//     increment = (step) => {
        
//         this.setState({
//             count: this.state.count + step
//         });

//     }

//     // Lifecycle function
//     render() {
//         //alert("Component render called!");
//         const {count} = this.state; // THis WAS const count = this.state.count; so the new version is cleaner
//         const {title} = this.props;

//         return (
//             <div className="counter-app">
//                 <h1>{title}</h1>
//                 <h2>I am counter app!</h2>
//                 <h1 className="value">{count}</h1>
//                 <button onClick={() => this.increment(-1)}>Decrement</button>
//                 <button onClick={() => this.increment(1)}>Increment</button>

//             </div>
//         )
//     }

// }
// CounterApp.propTypes = {
//     title: PropTypes.string.isRequired
// }



export default CounterApp;


// ##### WHAT I LEARNED: #######


// Class component
// Class comp is usually bigger component!
// First way of implementing counting (NOT VERY USED OR GOOD):
// constructor() {
//     super();
//     this.increment = this.increment.bind(this);
//     this.decrement = this.decrement.bind(this);
// }

// state = {
//     count: 0
// }

// increment() {
    
//     this.setState({
//         count: this.state.count + 1
//     });
    
// }

// decrement() {
    
//     this.setState({
//         count: this.state.count - 1
//     });

// }



// Functional component: 
// It is easier to read and simple... and performance boosts (Small ones but not always!)... small components are usually functional...
// const CounterApp = () => {

//     // STATE (not props)
//     const [count, setCount] = useState(0); 

    

//     // cleaner version:
//     const increment = (step) => () => setCount(count + step);




//     return (

//         <div className="counter-app">
//             <h1>I am counter app!</h1>
//                 <h1 className="value">{count}</h1>
            
//             <button onClick={increment(-1)}>Decrement</button>
//             <button onClick={increment(1)}>Increment</button>

//         </div>
        
//     )

// }



///// -------------------------------------

/*  WHAT I LEARNED:::!!!!!!!!!!!!!!!!
    const increment = () => {
        setCount(count + 1);
    }

    const decrement = () => {
        setCount(count - 1);
    }
    */

    
    // if you do not want to use arrow function in button onClick then:
    /*
        const increment = (step) => {
            return function() {
                setCount(count + step);
            }
            
        }

        THE SAME AS ABOVE BUT CLEANER:
        const increment = (step) => () => setCount(count + step);

        e.g.
        <button onClick={increment(-1)}>Decrement</button>
        <button onClick={increment(1)}>Increment</button>

    IF you DO NOT MIND arrow funtions in onClick then:
    const increment = (step) => {
        setCount(count + step);
    }

    <button onClick={() => increment(-1)}>Decrement</button>
    <button onClick={() => increment(1)}>Increment</button>
    */

